import React, {useState} from 'react';
import {makeStyles} from '@material-ui/styles';
import {Grid} from '@material-ui/core';

import {
    SearchFilter,
    TotalUserList,
} from './components';
import {getAllCategory} from '../../apis/api';

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(2),
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
}));

const Error = () => (<div>Error</div>);

const Management = () => {
    const classes = useStyles();

    // ID 선택
    const [userID, setUserID] = useState('');
    const changeUserID = ((id) => {
        setUserID(id === '' ? null : id);
    });

    // Name 선택
    const [userName, setUserName] = useState('');
    const changeUserName = ((name) => {
        setUserName(name === '' ? null : name);
    });

    // 카테고리 선택
    const [category, setCategory] = useState({});
    const changeCategory = (cate = {}) => {
        setCategory(cate);
    };

    // 대카테고리 리스트 가져오기
    const [categoryList, setCategoryList] = useState([]);
    if (categoryList.length === 0) {
        getAllCategory()
            .then((res) => {
                if (res.statusCode === 0) return errorHandler();

                setCategoryList(res);
            }).catch(() => {
                return errorHandler();
            });
    }

    const errorHandler = () => <Error />;

    const [filterProps, setFilterProps] = useState({});
    const onSubmit = () => {
        alert(`userID: ${userID}\n userName: ${userName} \n category: ${JSON.stringify(category)}`);
        setFilterProps({
            accountId: userID,
            name: userName,
            category1Name: category.parentName,
            category2Name: category.name,
        })
    };

    return (
        <div className={classes.root}>
            <Grid
                container
                spacing={2}
            >
                <Grid
                    item
                    lg={12}
                    md={12}
                    xl={12}
                    xs={12}
                >
                    <SearchFilter
                        categoryList={categoryList}
                        changeUserID={changeUserID}
                        changeUserName={changeUserName}
                        changeCategory={changeCategory}
                        onSubmit={onSubmit}
                    />
                </Grid>

                <Grid
                    item
                    lg={12}
                    md={12}
                    xl={12}
                    xs={12}
                >
                    <TotalUserList filterProps={filterProps}/>
                </Grid>
            </Grid>
        </div>
    );
};

export default Management;
